function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.65 7C8.4835 7 9.975 5.43 9.975 3.5C9.975 1.57 8.4835 0 6.65 0C4.8165 0 3.325 1.57 3.325 3.5C3.325 5.43 4.8165 7 6.65 7ZM6.65 2C7.4385 2 8.075 2.67 8.075 3.5C8.075 4.33 7.4385 5 6.65 5C5.8615 5 5.225 4.33 5.225 3.5C5.225 2.67 5.8615 2 6.65 2ZM6.65 8.75C4.427 8.75 0 9.92 0 12.25V14H13.3V12.25C13.3 9.92 8.873 8.75 6.65 8.75ZM2.223 12C3.021 11.42 4.9495 10.75 6.65 10.75C8.3505 10.75 10.279 11.42 11.077 12H2.223ZM13.338 8.81C14.44 9.65 15.2 10.77 15.2 12.25V14H19V12.25C19 10.23 15.675 9.08 13.338 8.81ZM12.35 7C14.1835 7 15.675 5.43 15.675 3.5C15.675 1.57 14.1835 0 12.35 0C11.837 0 11.362 0.13 10.925 0.35C11.5235 1.24 11.875 2.33 11.875 3.5C11.875 4.67 11.5235 5.76 10.925 6.65C11.362 6.87 11.837 7 12.35 7Z",
  fill: "white"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.aaef9435.svg";
export { ForwardRef as ReactComponent };